<template>
  <div class="modal fade" id="zoom-in-evidence-image-modal" role="dialog" @click="$emit('close')">
    <div class="modal-dialog modal-xl" @click.stop>
      <div class="modal-content">
        <div class="modal-body">
          <div class="box-evidence-image">
            <img class="evidence-image img-responsive" :src="imagePath">
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn w-100" data-dismiss="modal" @click="$emit('close')">閉じる</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    imagePath: {
      type: String,
      default: ''
    }
  },
  mounted () {
    $('#zoom-in-evidence-image-modal').modal('show')
  },
  beforeDestroy () {
    this.$emit('close')
    $('.modal-backdrop').remove()
  }
}
</script>

<style scoped>
#zoom-in-evidence-image-modal .modal-body {
  max-height: 1000px;
  overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// src/view/warehouseAmazon/ZoomInEvidenceImageModal.vue